// extracted by mini-css-extract-plugin
var _1 = "webpack-components-FullTextBulkUploader-components-BulkPDFUploader-BulkPDFUploader-module__BulkPDFUploader__error";
var _2 = "webpack-components-FullTextBulkUploader-components-BulkPDFUploader-BulkPDFUploader-module__dragged";
export { _1 as "BulkPDFUploader__error", _2 as "dragged" }
